import { lazy, Suspense } from "react";
import { Eyebrow, Reveal } from "./Reveal";
import { IMG, ORIGINS, DESTS } from "./data";

const TradeGlobe = lazy(() => import("./TradeGlobe").then((m) => ({ default: m.TradeGlobe })));

const List = ({ title, items, gold }) => (
  <div>
    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">{title}</p>
    <ul className="mt-4 space-y-3">
      {items.map((o, i) => (
        <li key={o} className="flex items-center gap-3">
          <span className={`h-2 w-2 shrink-0 rounded-full ${gold && i === 0 ? "bg-gold-light shadow-[0_0_0_5px_rgba(217,181,86,0.25)]" : "bg-white/70"}`} />
          <span className={`font-display font-bold ${gold && i === 0 ? "text-xl text-gold-light" : "text-base text-slate-200"}`}>{o}</span>
        </li>
      ))}
    </ul>
  </div>
);

export const Network = () => (
  <section id="corridor" className="relative overflow-hidden bg-navy-deep py-24 text-white sm:py-32" data-testid="corridor-section">
    <img src={IMG.containers} alt="" className="absolute inset-0 h-full w-full object-cover opacity-[0.08]" />
    <div className="relative mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <div className="min-w-0 lg:col-span-5">
        <Eyebrow light>The Zenura Corridor</Eyebrow>
        <Reveal>
          <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-6xl">
            Many sources. <em className="font-serif font-normal italic text-gold-light">One trusted</em> route to market.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-md text-base leading-relaxed text-slate-300 md:text-lg">We link international suppliers, recyclers and yards to buyers in India and other markets — one relationship at a time.</p>
        </Reveal>
        <Reveal delay={0.15} className="mt-12 grid grid-cols-2 gap-6 sm:gap-8" >
          <div data-testid="corridor-origins"><List title="Supply" items={ORIGINS} /></div>
          <div data-testid="corridor-destinations"><List title="Demand" items={DESTS} gold /></div>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="mx-auto w-full min-w-0 max-w-[640px] lg:col-span-7">
        <Suspense fallback={<div className="aspect-square w-full animate-pulse rounded-full bg-white/5" />}>
          <TradeGlobe />
        </Suspense>
      </Reveal>
    </div>
  </section>
);
